import type { Queue } from "../../api/quotations";

/** The work queue's sections, in the order the rail shows them, said for
 * whoever is looking. The server decides which queue a job is in; this only
 * names the queues. `mine` draws the count dark: the job waits on the viewer
 * rather than on somebody else. */
export interface QueueSection {
  key: Exclude<Queue, "done">;
  label: string;
  hint: string;
  mine: boolean;
}

const OFFICE: readonly QueueSection[] = [
  { key: "approve", label: "Approve", hint: "Submitted, waiting on you", mine: true },
  { key: "price", label: "Price and issue", hint: "Orders with unpriced lines", mine: true },
  { key: "capture", label: "Finish capturing", hint: "Drafts and returned quotes", mine: true },
  { key: "bill", label: "Bill the City", hint: "City order or invoice due", mine: true },
  { key: "supplier", label: "Waiting on supplier", hint: "Issued, not acknowledged", mine: false },
];

/** A supplier's own view of the same queues: what the office calls "waiting on
 * supplier" is the one that waits on them (Fix #21 -- the office's words are
 * not the supplier's). */
const SUPPLIER: readonly QueueSection[] = [
  { key: "supplier", label: "Acknowledge", hint: "Orders issued to you", mine: true },
  { key: "capture", label: "Finish capturing", hint: "Drafts and returned quotes", mine: true },
  { key: "approve", label: "With the office", hint: "Submitted, awaiting a decision", mine: false },
  { key: "price", label: "Being ordered", hint: "Approved, order not yet issued", mine: false },
  { key: "bill", label: "Ordered", hint: "Acknowledged, being billed", mine: false },
];

export function sectionsFor(supplierView: boolean): readonly QueueSection[] {
  return supplierView ? SUPPLIER : OFFICE;
}

export function queueLabel(queue: Queue, supplierView: boolean): string {
  if (queue === "done") {
    return "Done";
  }
  return sectionsFor(supplierView).find((section) => section.key === queue)?.label ?? queue;
}
